<template>
  <!-- NOTE wrap with … -->
  <!-- note if h tag, then … -->
  <div
    v-if="text"
    :class="$style.root"
    v-html="text"
  />
</template>

<script lang="ts" setup>
const props = defineProps<{
  text: string
}>()
</script>

<style module>
.root {
  composes: reset-heading from global;
  composes: font-size-medium from global;
  text-transform: uppercase;

  --block--margin-top: calc(var(--unit--vertical) * 2);
}
</style>
